import { render, staticRenderFns } from "./OrigenView.vue?vue&type=template&id=bc30d846"
import script from "./OrigenView.vue?vue&type=script&lang=js"
export * from "./OrigenView.vue?vue&type=script&lang=js"
import style0 from "./OrigenView.vue?vue&type=style&index=0&id=bc30d846&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports